import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { CellularPayPrompt } from './types'
import { color } from './tokens'
import { affectedControllers, isSuspendedStage, payableSimStage } from './sim-status'

const useNoticeStyles = makeStyles({
  box: {
    padding: '12px 16px',
    borderRadius: 8,
    fontSize: 14,
    lineHeight: '20px',
    color: color.foreground,
    textAlign: 'center'
  },
  warning: { backgroundColor: color.warning15 },
  destructive: { backgroundColor: color.destructive15 },
  text: { margin: 0, fontWeight: 500 },
  list: { margin: '8px 0 0', padding: 0, listStyle: 'none' }
})

interface SimStatusNoticeProps {
  prompt: CellularPayPrompt
  // The owner's wording or a member's: only the owner is asked to pay.
  message: string
}

// Where the bill's SIMs are in collections, and (once any is off) which
// controllers. Nothing when every SIM is active.
export const SimStatusNotice: FC<SimStatusNoticeProps> = ({ prompt, message }) => {
  const classes = useNoticeStyles()
  const stage = payableSimStage(prompt)
  if (!stage || !message) return null
  const suspended = isSuspendedStage(stage)
  const names = suspended ? affectedControllers(prompt) : []
  return (
    <div
      className={`${classes.box} ${suspended ? classes.destructive : classes.warning}`}
      data-testid='cellular-sim-status'
    >
      <p className={classes.text}>{message}</p>
      {names.length > 0 && (
        <ul
          aria-label='Affected controllers'
          className={classes.list}
        >
          {names.map(name => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
